import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  useLocation
} from "react-router-dom";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import HomeIcon from "@mui/icons-material/Home";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import PhoneIcon from "@mui/icons-material/Phone";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import { styled } from "@mui/material/styles";
import { ReservationProvider, useReservation } from './ReservationContext';
import { MatomoProvider, createInstance, useMatomo } from '@datapunt/matomo-tracker-react'

import HomeComponent from './HomeComponent';
import { MenuComponent } from './MenuComponent';
import ReservationComponent from './ReservationComponent';
import "./main.css";

const StyledBottomNavigation = styled(BottomNavigation)({
  backgroundColor: "#4b949c",
  position: "fixed",
  bottom: 0,
  width: "100%",
  boxShadow: "0 -4px 12px rgba(0, 0, 0, 0.15)",
  zIndex: 1000,
});

const StyledBottomNavigationAction = styled(BottomNavigationAction)(({ theme }) => ({
  color: "rgba(255, 255, 255, 0.85)",
  transition: "all 0.3s ease",
  "&.Mui-selected": {
    color: "#ffffff",
    transform: "scale(1.05)",
    fontWeight: 600,
  },
  "&:hover": {
    color: "#ffffff",
  },
  "& .MuiBottomNavigationAction-label": {
    fontSize: "0.75rem",
    "&.Mui-selected": {
      fontSize: "0.8rem",
    },
  },
}));

const matomoInstance = createInstance({
  urlBase: 'https://baeren-table-matomo.cr.baeren-lechtal.com',
  siteId: 1,
  configurations: { // optional, default value: {}
    // any valid matomo configuration, all below are optional
    disableCookies: true,
    setSecureCookie: true,
    setRequestMethod: 'POST'
  }
})


const Home = () => <HomeComponent />;
const Reservieren = () => <ReservationComponent />;
const Menu = () => <MenuComponent />;
const Call = () => <HomeComponent />;

const BottomNav = () => {
  const [value, setValue] = React.useState(0);
  const { trackEvent } = useMatomo()
  const navigate = useNavigate();

  const handleNavigation = (newValue) => {
    setValue(newValue);
    switch (newValue) {
      case 0:
        navigate("/");
        break;
      case 1:
        navigate("/reservation");
        break;
      case 2:
        navigate("/menu");
        break;
      case 3:
        navigate("/");
        break;
      default:
        break;
    }
  };

  return (
    <StyledBottomNavigation
      value={value}
      sx={{ backgroundColor: "#4b949c", zIndex: 100 }}
      onChange={(event, newValue) => handleNavigation(newValue)}
      showLabels
    >

      <StyledBottomNavigationAction
        label="Home"
        icon={<HomeIcon />}
      />
      <StyledBottomNavigationAction
        label="Reservieren"
        icon={<EventAvailableIcon />}
      />
      <StyledBottomNavigationAction
        label="Speisekarte"
        icon={<MenuBookIcon />}
      />
      <StyledBottomNavigationAction
        label="Anruf"
        onClick={() => {
          trackEvent({ category: 'lead', action: 'call-event' });
          window.location.href = "tel:+4356335217";
        }}
        icon={<PhoneIcon />}
      />
    </StyledBottomNavigation>
  );
};

const SetReservationSource = () => {
  const { trackEvent } = useMatomo();
  const { setReservationState } = useReservation();
  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const sourceVal = queryParams.get("s");
    if (sourceVal) {
      trackEvent({ category: 'lead', action: 'start-event', name: sourceVal });
      setReservationState((prevState) => ({
        ...prevState,
        source: sourceVal,
      }));
    }
  }, [location]);

  return null;
};

const SetRestDays = () => {
  const { setReservationState } = useReservation();

  useEffect(() => {
    const fetchRestDays = async () => {
      try {
        const response = await fetch("https://baeren-table-api.cr.baeren-lechtal.com/restdays");
        if (response.ok) {
          const data = await response.json();

          // Update the reservation state with rest days
          setReservationState((prevState) => ({
            ...prevState,
            restdays: data.restdays,
          }));
        } else {
          console.error("Failed to fetch rest days:", response.statusText);
        }
      } catch (error) {
        console.error("Error fetching rest days:", error);
      }
    };

    fetchRestDays();
  }, [setReservationState]);

  return null; // This component doesn't render anything
};

const App = () => {
  return (
    <MatomoProvider value={matomoInstance}>
      <ReservationProvider>
        <Router>
          <SetReservationSource />
          <SetRestDays />
          <div>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/reservation" element={<Reservieren />} />
              <Route path="/menu" element={<Menu />} />
              <Route path="/call" element={<Call />} />
            </Routes>
            <BottomNav />
          </div>
        </Router>
      </ReservationProvider>
    </MatomoProvider>
  );
};

export default App;
